import { api } from "./api";

export const logout = () => api.get("/auth/logout");

export const login = (code) => api.get(`/auth/login?code=${code}`);
